// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__dX7hh","label":"styles_label__IC_2K","icon":"styles_icon__ZGmzI"};